export default "__VITE_ASSET__Dbcvo_k6__"